<template>
    <div class="mt-4">
        <h5 class="status-label">Connection Information</h5>
        <template v-if="model.credentials.user && model.credentials.hub_domain && model.credentials.hub_id">
            <el-row :gutter="20" class="mt-2">
                <el-col :span="24">
                    <span class="mt-2"><b>Email:</b> {{ model.credentials.user }}</span>
                </el-col>
                <el-col :span="24" class="mt-2">
                    <span><b>Account Name:</b> {{ model.credentials.hub_domain }}</span>
                </el-col>
                <el-col :span="24" class="mt-2">
                    <span><b>Account ID:</b> {{ model.credentials.hub_id }}</span>
                </el-col>
            </el-row>
        </template>
        <template v-if="model.credentials.scopes">
            <el-row :gutter="20" class="mt-2">
                <el-col :span="24">
                    <span><b>Scopes:</b></span>
                </el-col>
                <el-col :span="24" class="mt-2">
                    <code>{{ model.credentials.scopes }}</code>
                </el-col>
            </el-row>
        </template>
        <template v-if="model.credentials.user">
            <el-row :gutter="20" class="mt-2">
                <el-col :span="24">
                        <span><b>UI Domain:</b>
                            {{  model.credentials.uiDomain ? model.credentials.uiDomain : 'Please re-authenticate to fetch from HubSpot (default: app.hubspot.com)' }}
                        </span>
                </el-col>
            </el-row>
        </template>
    </div>
</template>
<script>
export default {
    props: {
        model: {
            type: Object,
            required: true
        },
    }
}
</script>
